<template>
  <div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'guest-login',
    props: ['openId', 'token'],
    data: () => {
      return {
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      ...mapActions([
        'loadGuestUserToken',
        'loadGuestUser',
        'loadEntityTypeLabelConfiguration'
      ]),
      loadData () {
        let openId = this.$route.query.openId

        this.loadGuestUserToken({ openId: openId }).then((token) => {
          this.loadGuestUser({ token: token }).then((userObj) => {
            this.setUserInfo(userObj, token)
            this.loadEntityTypeLabelConfiguration(openId).then((labelConfig) => {
              this.populateEntityTypeLabelConfiguration(openId, labelConfig)
              if (userObj && userObj) {
                return this.$router.push({ name: 'catalogSearchResults' })
              }
            })
          })
        })
      },
      setInstitutionInfo (openId) {
        this.populateEntityTypeLabelConfiguration(openId)
        if (openId === '0000000KENYON') {
          localStorage.setItem('institution', 'kenyon')
        } else if (openId === 'PRAGYA_TEMP_OPEN_ID_FOR_QUT') {
          localStorage.setItem('institution', 'qut')
        } else if (openId === 'PRAGYA_TEMP_OPEN_ID_FOR_NU') {
          localStorage.setItem('institution', 'nu')
        } else if (openId.indexOf('PRAGYA_TEMP_OPEN_ID_FOR_STANFORD') > -1) {
          localStorage.setItem('institution', 'stanford')
        } else if (this.institution.title.toLowerCase() === 'teachercraft') {
          localStorage.setItem('institution', 'teachercraft')
        }
      },
      setUserInfo (userObj, openId) {
        if (!userObj || !openId) {
          return
        }
        this.setInstitutionInfo(openId)
        localStorage.setItem('isGuestLogin', true)
        localStorage.setItem('openId', openId)
        if(userObj.password !== "*&^^&*"){
          localStorage.setItem('token', userObj.password)
        }
        localStorage.setItem('loginTime', new Date())
        localStorage.setItem('userFullName', userObj.firstName + ' ' + userObj.lastName)
        localStorage.setItem('userid', userObj.uuid)
        localStorage.setItem('userrole', userObj.roles[0].role)
        localStorage.setItem('user_personal_LS_UUID', userObj.personalLearningSpaceUUID)
        localStorage.setItem('userobj', JSON.stringify(userObj))
        localStorage.setItem('version', userObj.permission.version)
        // For Lasso
        localStorage.setItem('baseUrl', window.location.origin)
      },
      populateEntityTypeLabelConfiguration (openId, labelConfig) {
        if (!labelConfig) {
          return
        }
        if (labelConfig.hasOwnProperty(openId)) {
          let configuration = labelConfig[openId]
          localStorage.setItem('entityTypeLabelConfiguration', JSON.stringify(configuration))
        }
      }
    },
    computed: {
      ...mapState({
        'guestUserToken': state => state.guest.guestUserToken,
        'guestUser': state => state.guest.guestUser,
        'entityTypeLabelConfiguration': state => state.guest.entityTypeLabelConfiguration,
        'institution': state => state.institution.institution
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/guest/components/GuestLogin.vue